import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer-basic-layout',
  templateUrl: './footer-basic-layout.component.html',
  standalone: false
})
export class FooterBasicLayoutComponent implements OnInit {
  @Input({ required: false }) customClass = '';

  constructor() { }

  ngOnInit() {
  }

}
